// extracted by mini-css-extract-plugin
module.exports = {"button-group":"ButtonGroup_button-group__12UJ6","btn-cart":"ButtonGroup_btn-cart__3dIrp","btn-ask":"ButtonGroup_btn-ask__27Xyf","btn-delete":"ButtonGroup_btn-delete__1B9zV"};